export const gallery = (theme) => ({
    /* Styles applied to the root element. */
    gallery: {
        display: "grid",
        gridTemplateColumns: "repeat( auto-fit, minmax(250px, 1fr) )",
        gridTemplateRows: "repeat( auto-fit, minmax(150px, 372px) )",
        gridTemplateAreas:
            '"a0 a0 a1 a1"\n"a0 a0 a2 a3"\n"aOthers aOthers aOthers aOthers"',
        gridGap: theme.spacing(1),
        [theme.breakpoints.down("md")]: {
            gridTemplateAreas:
                '"a0 a0"\n"a0 a0"\n"a1 a1"\n"a2 a3"\n"aOthers aOthers"\n"aOthers aOthers"',
        },
        [theme.breakpoints.down("xs")]: {
            gridTemplateColumns: "repeat( auto-fit, minmax(150px, 1fr) )",
            gridTemplateRows: "repeat( auto-fit, minmax(50px, 372px) )",
        },
    },
    background: {
        height: "100%",
        width: "100%",
        minHeight: 372,
        backgroundPosition: "center center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        [theme.breakpoints.down("md")]: {
            minHeight: 350,
        },
        [theme.breakpoints.down("xs")]: {
            minHeight: 200,
        },
    },
});
